import addEventListener from 'utils/DOM/addEventListener'
import removeEventListenerBySelector from 'core/DOM/removeEventListenerBySelector'
import { IS_FIXED_BENEFIT_MEDICAL, IS_SHORT_TERM } from 'core/constants/environment'
import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import buildControllerGender from 'core/controllers/buildControllerGender'
import buildControllerDOB from 'core/controllers/buildControllerDOB'
import removeElements from 'utils/DOM/removeElements'
import { stringToDate, alterDate, stringToAge } from '@hc-frontend/utils'
import toggleClass from 'utils/DOM/toggleClass'
import getById from 'utils/DOM/getById'
import { MemberType } from '@hc-frontend/entities'

const spouseWrap = getById('spouse-wrap')
const childrenWrap = getById('children-wrap')
const template = Templater(getById('template-member').innerText)
const addSpouseButton = getById('add-spouse')
const controllers = {}
const SUFFIX_TO_SPOUSE = 's'
const MAX_CHILDREN = 10
let totalChild = 0
let suffixChild = 0
let thereIsSpouse = false
const templateWeek = Templater(getById('template-week').innerText)
let getSdate
let productType

export function updateControllerRules(product) {
  productType = product
  Object.keys(controllers).forEach(key => {
    if (
      key.includes('dob') &&
      controllers[key].getState().typeMember === MemberType.Child
    ) {
      controllers[key].setCallOnFocus(productType === 'fbm' ? removeWeek : undefined)
      controllers[key].setCallOnValidate(
        productType === 'fbm' ? validateWeekChild : undefined
      )
      controllers[key].validate()
      if (product !== 'fbm') {
        removeWeek(controllers[key].getState())
      }
    }
  })
}

function removeMemberById(id) {
  const suffix = id.split('_').pop()
  const dobId = `dob_${suffix}`
  const genderId = `gender_${suffix}`
  removeEventListenerBySelector(`#${id} .c-Form__close`, 'click', removeMember)
  removeElements(`#${id}`)
  controllers[dobId].destroy()
  controllers[genderId].destroy()
  delete controllers[dobId]
  delete controllers[genderId]

  if (suffix === SUFFIX_TO_SPOUSE) {
    addSpouseButton.disabled = false
    thereIsSpouse = false
  } else {
    totalChild -= 1
    addChildButton.disabled = false
  }
}

function removeMember(e) {
  return removeMemberById(e.target.getAttribute('data-id'))
}

const addedTo = {}

function removeWeek(status) {
  const nameInput = status.input.name
  if (addedTo[nameInput]) {
    addedTo[nameInput] = false
    removeElements(`#id-week-${nameInput}`)
  }
}

function validateWeekChild(status) {
  const nameInput = status.input.name
  if (status.valid) {
    const date = stringToDate(status.input.value)
    const back6Months = alterDate({ months: -6 })
    if (!addedTo[nameInput] && back6Months.getTime() < date.getTime()) {
      addedTo[nameInput] = true
      const element = document.createElement('div')
      element.innerHTML = templateWeek({ id: nameInput })
      element.id = `id-week-${nameInput}`

      const parent = getById(`wrap-${status.input.id}`)
      parent.appendChild(element)
    }
  } else {
    removeWeek(status)
  }
}

function createMember(config, member = {}) {
  const htmlObject = document.createElement('div')
  htmlObject.id = config.id
  htmlObject.innerHTML = template(config)

  if (config.type === MemberType.Spouse) {
    spouseWrap.appendChild(htmlObject)
  } else {
    childrenWrap.appendChild(htmlObject)
  }

  let showWeekCheckup = IS_FIXED_BENEFIT_MEDICAL && config.type === MemberType.Child

  if (IS_SHORT_TERM) {
    showWeekCheckup = productType === 'fbm' && config.type === MemberType.Child
  }

  const dobId = `dob${config.suffix}`
  controllers[dobId] = buildControllerDOB({
    input: getById(dobId),
    typeMember: config.type,
    callOnValidate: showWeekCheckup && validateWeekChild,
    callOnFocus: showWeekCheckup && removeWeek,
    getSdate: () => getSdate()
  })

  controllers[dobId].setValue(member.stringDOB)
  if (member.stringDOB) {
    controllers[dobId].validate()
  }

  const genderId = `gender${config.suffix}`
  controllers[genderId] = buildControllerGender({
    inputs: document.forms.form[genderId]
  })
  controllers[genderId].setValue(member.gender)
  if (member.gender) {
    controllers[genderId].validate()
  }
  if (showWeekCheckup) {
    validateWeekChild(controllers[dobId].getState())
  }

  addEventListener(`#${config.id} .c-Form__close`, 'click', removeMember)
}

addEventListener('#add-spouse', 'click', () => addSpouse({}))
export function addSpouse(member) {
  addSpouseButton.disabled = true
  const suffix = SUFFIX_TO_SPOUSE
  thereIsSpouse = true

  createMember(
    {
      id: suffix,
      title: 'Your Spouse',
      suffix: `_${suffix}`,
      type: MemberType.Spouse
    },
    member
  )
}

addEventListener('#add-child', 'click', () => addChild())
const addChildButton = getById('add-child')
function addChild(member) {
  if (totalChild < MAX_CHILDREN) {
    totalChild += 1
    suffixChild += 1

    createMember(
      {
        id: `c_${suffixChild}`,
        title: 'Child',
        suffix: `_${suffixChild}`,
        type: MemberType.Child
      },
      member
    )
  }
  addChildButton.disabled = totalChild === MAX_CHILDREN
}

function loadMembers(members) {
  for (let index = 0; index < members.length; index++) {
    const member = members[index]

    if (member.type === MemberType.Spouse) {
      addSpouse(member)
    } else if (member.type === MemberType.Child) {
      addChild(member)
    }
  }
}

function isUnder18YearsOfAge(date) {
  return !!date && stringToAge(date) < 18
}

function setChildOnlyApplication(isChildOnly) {
  if (isChildOnly) {
    if (thereIsSpouse) {
      removeMemberById('s')
    }
  }
  toggleClass(document.body, 'child-only', isChildOnly)
}

export default {
  updateControllerRules,
  setGetSdate: fn => {
    getSdate = fn
  },
  loadMembers,
  getControllers: () => controllers,
  setChildOnlyApplication: setChildOnlyApplication,
  childOnly: isUnder18YearsOfAge
}
